module.exports = __webpack_public_path__ + "assets/images/DEPOSIT.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/DEPOSIT.png
// module id = 1353
// module chunks = 1